(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/news/assets/javascripts/helpers/handlebar-helper.js') >= 0) return;  svs.modules.push('/components/sport/news/assets/javascripts/helpers/handlebar-helper.js'); 
'use strict';

(function() {
  if (svs.isServer) {
    registerHelpers(require('hbs'));
  } else {
    registerHelpers(Handlebars);
  }

  function registerHelpers() {
    Handlebars.registerHelper('formattedDate', function(created) {
      var ret = '';
      if (created) {
        ret = formatDate(created);
      }
      return new Handlebars.SafeString(ret);
    });

    function formatDate(sDateTime) {
      if (!window.moment || !sDateTime) {
        return '';
      }

      var published = moment(sDateTime),
        ageInMinutes = moment
          .duration(moment().diff(moment(sDateTime)))
          .asMinutes(),
        formattedString;

      if (ageInMinutes >= 0 && ageInMinutes < 1) {
        formattedString = 'mindre än en minut';
      } else if (ageInMinutes >= 1 && ageInMinutes <= 59) {
        formattedString = Math.floor(ageInMinutes) + ' min';
      } else {
        formattedString =
          published.format('D/M') + ' kl. ' + published.format('H.mm');
      }

      return formattedString;
    }
  }
})();

 })(window);